<template>
  <a-modal
    :title="modalTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :mask-closable="false"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <h3>{{ $t('message["794"]') }}：</h3>
    <a-form
      :form="form"
      :hide-required-mark="true"
    >
      <a-form-item>
        <a-input
          v-decorator="['reason', {
            rules: [{ required: true, message: reasonNeed}],
            initialValue: reason || ''
          }]"
          :placeholder="enterPlaceholder"
          class="input"
        />
      </a-form-item>
    </a-form>
    <p>{{ $t('message["1165"]') }}。</p>
  </a-modal>
</template>

<script>
import { inquiryApply } from '@/services/inqueryServices'

const FROM_SOPURCE = 'notice'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      confirmLoading: false,
      reason: ''
    }
  },
  computed: {
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    reasonNeed () {
      return this.$t('message["1043"]')
    },
    modalTit () {
      return this.$t('message["1621"]')
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
    },
    async handleOk () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true
          this.reason = this.form.getFieldValue('reason')
          const chain = await inquiryApply()
          chain
            .setForm(this.form)
            .params({
              inquiryid: this.inquiryId,
              reason: this.reason
            })
            .onNetSuccess(raw => {
              this.confirmLoading = false
              this.handleCancel()
            })
            .onSuccess(payload => {
              const { from } = this.$route.query
              if (from === FROM_SOPURCE) {
                this.$router.push({ name: 'recordNotice' })
              } else if (from === 'webhook') {
                this.$router.push({
                  name: 'configSendRecord',
                  params: {
                    hookid: this.$route.query.hookid
                  }
                })
              } else if (from === 'clue') {
                this.$router.push({
                  name: 'InqueryClue'
                })
              } else if (from === 'ocpc') {
                this.$router.push({
                  name: 'ocpc'
                })
              } else {
                this.$router.push({
                  name: 'InqueryList',
                  query: {
                    ...this.$route.query
                  }
                })
              }
            })
            .fetch()
        }
      })
    },
    handleCancel () {
      this.hide()
      this.form.resetFields()
      this.reason = ''
      this.confirmLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input {
  margin: 20px 0;
}
</style>
